import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export interface ProjectStats {
  totalInstances: number;
  runningNow: number;
  totalTokens: number;
  totalCostUsd: number;
  costByDay: { date: string; cost: number; tokens: number }[];
  instancesByStatus: Record<string, number>;
  topAgents: {
    agentId: string;
    agentName: string;
    instanceCount: number;
    totalCost: number;
    avgCost: number;
    totalTokens: number;
  }[];
}

export function useProjectStats(projectId: string | undefined) {
  return useQuery<ProjectStats>({
    queryKey: ['projects', projectId, 'stats'],
    queryFn: async () => {
      const res = await api.get(`/api/projects/${projectId}/stats`);
      return res.data;
    },
    enabled: !!projectId,
  });
}
